// Stripe integration helpers
// Note: You'll need to add your Stripe keys to your environment

const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || ''

export const isStripeConfigured = () => {
  return !!STRIPE_PUBLISHABLE_KEY
}

export const getStripePublishableKey = () => STRIPE_PUBLISHABLE_KEY

// Load Stripe.js dynamically
let stripePromise = null

export const getStripe = async () => {
  if (!isStripeConfigured()) {
    console.warn('Stripe is not configured. Add VITE_STRIPE_PUBLISHABLE_KEY to your environment.')
    return null
  }

  if (!stripePromise) {
    const { loadStripe } = await import('@stripe/stripe-js')
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY)
  }

  return stripePromise
}

// Format currency for Stripe (convert dollars to cents)
export const toCents = (dollars) => Math.round(dollars * 100)
export const fromCents = (cents) => cents / 100

// Create a payment link for an invoice
export const createPaymentLink = async (invoice, supabaseClient) => {
  // This would typically call a Supabase Edge Function that handles Stripe API calls
  // For now, we'll return a placeholder
  console.log('Creating payment link for invoice:', invoice.id)

  // In production, you'd call:
  // const { data, error } = await supabaseClient.functions.invoke('create-payment-link', {
  //   body: { invoiceId: invoice.id }
  // })

  return {
    url: null,
    error: 'Stripe Edge Function not configured. Set up supabase/functions/create-payment-link'
  }
}

// Invoice status helpers
export const INVOICE_STATUSES = {
  draft: { label: 'Draft', color: 'var(--gray-500)', badge: 'default' },
  sent: { label: 'Sent', color: 'var(--primary)', badge: 'active' },
  paid: { label: 'Paid', color: 'var(--success)', badge: 'active' },
  overdue: { label: 'Overdue', color: 'var(--error)', badge: 'archived' },
  cancelled: { label: 'Cancelled', color: 'var(--gray-400)', badge: 'paused' },
  refunded: { label: 'Refunded', color: 'var(--warning)', badge: 'planning' },
}

export const getInvoiceStatusConfig = (status) => {
  return INVOICE_STATUSES[status] || INVOICE_STATUSES.draft
}
